// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__MTa75","checkmark":"style_checkmark__1s_20"};